import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// this file is based on https://react.i18next.com/guides/quick-start

const resources = {
    'en-HK': {
        translation: {
            customerSupport: 'Customer Support',
            invite: 'Chat with us! Let us know how we can help today.', // TODO this may load before we set the desired language...
            continue: 'Continue your ticket here', // TODO not used yet
            tnc: `Hello,\nI'm the sim Credit Card virtual assistant. I can answer enquiries about sim Credit Card's product and services. How may I help you today?\nBy starting this conversation, you indicate that you have read, agreed to, and accepted the [Terms and Conditions of the sim Credit Card virtual assistant service]({{TNC_EN}}).`,
            
            btnOffersLabel: 'Offers',
            btnOffersMessage: 'Hi, what products do you offer at thesim.com?',
            btnSimLabel: 'About Sim',
            btnSimMessage: 'Hi, can you introduce both sim Credit Card and sim World Mastercard® to me?',

            endCode4101: 'Chat ended due to inactivity.',
            endCode4102: 'You have ended the chat.',
            endCode4103: 'Chat ended by administrator.',
            endCode4104: 'You have reached the message limit for this thread. You can open another browser and start a new chat if needed.',
            endMessage: `Please make note of any important information before closing or minimizing the chat window.\nYou can start a new chat if necessary.\n\nRef No.: {{ticketId}}`,

            // SessionExtension.jsx and EndChatPrompt.jsx
            continueChatPrompt: 'Do you want to continue this chat?',
            endChatPrompt: 'Are you sure you want to end this chat?',
            continueChat: 'Continue chat',
            endChat: 'End chat',

            invalidMessage: 'Please avoid pasting URLs, scripts, or images directly into our conversation.',

            busyMessage: 'Thank you for your inquiry! We will get back to you as soon as possible!\n多謝你嘅查詢！我哋會盡快覆返你！',
        }
    },
    'zh-HK': {
        translation: {
            customerSupport: '客戶支援',
            invite: '同我哋傾偈啦！話我哋知你有咩需要啦。',
            continue: '喺度繼續傾計啦',
            tnc: `你好!\n我係sim Credit Card 智能助理，我可以為你解答關於sim Credit Card 嘅產品資料及服務。請問有咩可以幫到你?\n請注意，開始對話表示你已同意及接受[sim Credit Card智能助理之使用條款及細則]({{TNC_TC}})。`,

            btnOffersLabel: '產品',
            btnOffersMessage: '嗨，你哋喺 thesim.com 提供咩產品呀？',
            btnSimLabel: '關於 sim',
            btnSimMessage: '嗨，你可以介紹下sim Credit Card同產品sim World Mastercard®俾我聽嗎？',

            endCode4101: '由於閒置時間過長，聊天已被結束。',
            endCode4102: '你已結束了聊天。',
            endCode4103: '管理員已結束聊天。',
            endCode4104: '您已達到此對話窗口的訊息限制。如有需要，您可以打開另一個瀏覽器開始新的聊天。',
            endMessage: `在關閉或最小化聊天窗口之前，請務必記下任何重要信息。\n如有需要，你可以開始一個新的聊天。\n\nRef No.: {{ticketId}}`,

            // SessionExtension.jsx and EndChatPrompt.jsx
            continueChatPrompt: '你想繼續這個聊天嗎？',
            endChatPrompt: '你確定要結束這個聊天嗎？',
            continueChat: '繼續聊天',
            endChat: '結束聊天',

            invalidMessage: '請避免將 鏈結、腳本或圖像直接貼到我們的對話中。',

            busyMessage: '多謝你嘅查詢！我哋會盡快覆返你！\nThank you for your inquiry! We will get back to you as soon as possible!',
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en-HK',
        interpolation: {
            escapeValue: false // react is already safe from XSS
        }
    });

// Add a function to update TNC URLs at runtime
export function updateTNCUrls(tncEn, tncTc) {
    const enTranslations = i18n.getResourceBundle('en-HK', 'translation');
    const zhTranslations = i18n.getResourceBundle('zh-HK', 'translation');

    // Replace placeholders in the 'tnc' string
    enTranslations.tnc = enTranslations.tnc.replace('{{TNC_EN}}', tncEn);
    zhTranslations.tnc = zhTranslations.tnc.replace('{{TNC_TC}}', tncTc);

    // Update the resource bundles
    i18n.addResourceBundle('en-HK', 'translation', enTranslations, true, true);
    i18n.addResourceBundle('zh-HK', 'translation', zhTranslations, true, true);
}

export default i18n;
